import ReactDOM from 'react-dom/client'
import { App } from './App.tsx'
import '@/styles/global.css'

ReactDOM.createRoot(document.getElementById('athenas')!).render(<App />)
